<template>
  <div>
    <Modal v-model="visible" width="800px" title="详情" :footer-hide="true" :mask-closable="false" class="my-modal">
      <Form ref="form" :model="formData" :label-width="120" class="page-form less" v-loading="loading">
        <FormItem label="保单号">
          {{ formData.policyNo }}
        </FormItem>
        <FormItem label="机构">
          {{ formData.orgName }}
        </FormItem>
        <FormItem label="团队">
          {{ formData.groupName || '-' }}
        </FormItem>
        <FormItem label="业务员">
          {{ formData.agentName || '-' }}
        </FormItem>
        <FormItem label="投保人姓名">
          {{ formData.policyerName || '-' }}
        </FormItem>
        <FormItem label="投保产品">
          {{ formData.productName || '-' }}
        </FormItem>
        <FormItem label="收件人姓名">
          {{ formData.receiveName || '-' }}
        </FormItem>
        <FormItem label="收件人手机号">
          <div>
            <span v-if="!formData.eyeShow">{{ formData.receiveMoblie || '-' }}</span>
            <span v-else>{{ formData.receiveMoblie1 || '-' }}</span>
            <span v-if="formData.receiveMoblie">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow" @click="openEye(formData, 'eyeShow', 'receiveMoblie')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(formData, 'eyeShow', 'receiveMoblie')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="收件人和投保人的关系" class="full">
          <lzDicTxt dicType="PAPER_POLICY_RELATIONSHIP" :dicCode="formData.relationship"></lzDicTxt>
        </FormItem>
        <FormItem label="收件地址" class="full">
          <div>
            <span v-if="!formData.eyeShow1">{{ formData.receiveAddress || '-' }}</span>
            <span v-else>{{ formData.receiveAddress1 || '-' }}</span>
            <span v-if="formData.receiveAddress">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow1" @click="openEye(formData, 'eyeShow1', 'receiveAddress')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(formData, 'eyeShow1', 'receiveAddress')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="邮寄单号" v-if="formData.result == 3">
          {{ formData.mailOrderNo || '-' }}
        </FormItem>
        <FormItem label="失败原因" class="full" v-if="formData.result == 2">
          {{ formData.describe || '-' }}
        </FormItem>
        <FormItem label="完成日期" v-if="formData.result == 2 || formData.result == 3">
          {{ formData.finishDate | filterTime('YYYY-MM-DD') }}
        </FormItem>
        <FormItem label="申请时间">
          {{ formData.createTime | filterTime('YYYY-MM-DD HH:mm') }}
        </FormItem>
        <FormItem label="客户签收情况" class="full">
          <template v-if="formData.isFillSignInfo == '1'">
            <template v-if="formData.signType == '1'">
              {{ formData.sendName }}当面递交，{{ formData.signDate.split(' ')[0] }}签收，地址：{{ formData.signAddress }}
            </template>
            <template v-else>快递寄送，{{ formData.signMailCompany }}，单号：{{ formData.signMailOrderNo }} </template>
          </template>
          <template v-else>未签收</template>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import _ from 'lodash';
import { common } from '@/api/mixins';
export default {
  components: { lzDicTxt },
  mixins: [common],
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {}
    };
  },
  created() {},
  methods: {
    openEye(item, keyName, name) {
      let operationType;
      if (name == 'receiveMoblie') {
        operationType = 2;
      } else if (name == 'receiveAddress') {
        operationType = 5;
      }
      if (!item[keyName]) {
        this.descrypt(
          {
            query: this.formData.id,
            operationFunction: 20,
            operationType: operationType
          },
          item,
          name + '1'
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    open(data) {
      this.formData = {};
      this.visible = true;
      this.loading = false;
      this.$http({
        url: '/buz/paperPolicy/read/detail',
        data: {
          id: data.id
        }
      })
        .then(res => {
          this.formData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
